<template>
  <div>
    <div v-if="!loading">
      <div>
        <img
            v-if="image"
            :src="'/images/crop/' + image.id + '.' + image.attributes.extension+ '?q='+count"
            style="max-width: 300px; cursor: pointer"
            @click="edit"
        >

        <div v-else style="margin: 7px 0;">
          <i>
            No image selected
          </i>
        </div>
      </div>

      <button v-if="value && nullable" type="button" class="btn btn-xs btn-black" @click="$emit('input', null)">
        <i class="fa fa-minus"/> Remove
      </button>

      <button type="button" class="btn btn-xs btn-black" @click="openModal">
        <i class="fa fa-search"/> Select
      </button>

      <SelectModal :company-id="companyId" @select="$emit('input', $event.id)"/>
    </div>

    <EditModal :image="editing" @updated="count++"/>
  </div>
</template>

<script>
import http from '@/http'
import store from '@/store'
import EditModal from '@/components/Modals/Administration/Images/Edit'
import SelectModal from '@/components/Modals/Administration/Images/Select'

export default {
  components: {EditModal, SelectModal},

  props: {
    value: {},
    nullable: {},
    companyId: {
      required: false,
      type: [String, Number],
    },
  },

  data() {
    return {
      shared: store,

      loading: true,
      image: null,
      editing: null,
      count: 1
    }
  },

  mounted() {
    if (this.value) {
      return this.load()
    }

    this.loading = false
  },

  watch: {
    value() {
      if (this.value) {
        return this.load()
      }

      this.image = null
    },
  },

  methods: {
    load() {
      http.get('/api/v2/images/' + this.value).then(response => {
        this.image = response.data.data

        this.loading = false
      })
    },

    openModal() {
      $(this.$el.querySelector('.select-image-modal')).modal('show')
    },

    edit() {
      this.editing = this.image

      $(this.$el.querySelector('.edit-image-modal')).modal('show')
    },
  }
}
</script>
